module.exports = __webpack_public_path__ + "img/1.81091cd3.png";